const CategoriaList = () => import("~/components/Views/Prova/Categoria/List");
const CategoriaNew = () => import("~/components/Views/Prova/Categoria/New");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "/prova" },
  { name: "Classificação", link: "" }
];

export const categoria = [
  {
    path: "classificacao/categoria",
    component: CategoriaList,
    name: "Categoria",
    meta: {
      title: "Categoria",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "classificacao/categoria/new",
    component: CategoriaNew,
    name: "Nova Categoria",
    meta: {
      title: "Nova Categoria",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "classificacao/categoria/:id",
    component: CategoriaNew,
    name: "Alterar Categoria",
    meta: {
      title: "Alterar Categoria",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/classificacao/categoria.js